import { render, staticRenderFns } from "./phoneSms.vue?vue&type=template&id=5e239425&scoped=true"
import script from "./phoneSms.vue?vue&type=script&lang=js"
export * from "./phoneSms.vue?vue&type=script&lang=js"
import style0 from "./phoneSms.vue?vue&type=style&index=0&id=5e239425&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e239425",
  null
  
)

export default component.exports